import React, { useState } from 'react';
import { FiLayers, FiAlertCircle, FiCheckCircle, FiLock } from 'react-icons/fi';
import ButtonLoading from '../ButtonLoading';
import { userRequest } from '../../utils/requestMethods';
import { useStateContext } from '../../contexts/ContextProvider';

const EnableMultiFundBanner = ({ schoolId, onEnabled }) => {
  const { user, school } = useStateContext();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const isOwner = user?.role === 0 || (school && String(school?.user) === String(user?._id));

  const handleEnable = async () => {
    setLoading(true);
    setError('');
    try {
      const { data } = await userRequest.patch(`/schools/${schoolId}/finance/multi-fund`);
      onEnabled?.(data);
    } catch (err) {
      setError(err?.response?.data?.message || 'Failed to enable multi-fund mode. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="rounded-2xl border border-indigo-200 bg-indigo-50 px-6 py-6 mb-6">
      <div className="flex items-start gap-4">
        <div className="p-3 bg-white rounded-xl shrink-0">
          <FiLayers className="text-indigo-600 text-xl" />
        </div>
        <div className="flex-1">
          <h3 className="text-base font-semibold text-gray-900 mb-1">Enable Multi-Fund Finance</h3>
          <p className="text-sm text-gray-600 mb-4">
            Separate your school's money into named funds — by educational level or purpose — with
            expense tracking, reporting, reconciliation, and payroll. This is a one-time setup and creates
            a Default Fund automatically.
          </p>
          {error && (
            <div className="flex items-start gap-2 bg-red-50 border border-red-200 text-red-700 rounded-xl px-4 py-2.5 text-sm mb-3">
              <FiAlertCircle className="mt-0.5 shrink-0" />
              <span>{error}</span>
            </div>
          )}
          {loading ? (
            <ButtonLoading styles="text-white bg-indigo-500 font-medium rounded-full text-sm px-5 py-2.5" />
          ) : isOwner ? (
            <button
              type="button"
              onClick={handleEnable}
              className="inline-flex items-center gap-2 py-2.5 px-5 text-sm font-medium rounded-full text-white bg-indigo-600 hover:bg-indigo-700 shadow-sm transition-colors"
            >
              <FiCheckCircle className="w-4 h-4" />
              Enable Multi-Fund
            </button>
          ) : (
            <div className="inline-flex items-center gap-2 text-xs font-medium text-amber-700 bg-amber-50 border border-amber-200 rounded-full px-4 py-2">
              <FiLock className="w-3.5 h-3.5" />
              Only the School Owner can enable Multi-Fund mode.
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default EnableMultiFundBanner;
